<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>
      <h1>AA-accountant</h1>
      <p>
        <strong
          >De Nederlandse wet- en regelgeving wordt steeds complexer door de
          veranderende maatschappij. Als onderneming is het soms lastig het
          overzicht over al uw financiën, uitgaven en winst te behouden.
          Gelukkig is daar een adviseur voor in te huren: de
          Accountant-Administratieconsulent of AA-accountant. De AA-accountant
          werkt voornamelijk voor het midden- en kleinbedrijf en adviseert
          ondernemers op administratief, financieel, bedrijfseconomisch en
          fiscaal gebied.</strong
        >
      </p>

      <h2>Wat doet een AA-accountant?</h2>
      <p>
        Een AA-accountant is werkzaam bij de meest uiteenlopende bedrijven: van
        restaurant en bouwbedrijf tot boekenzaak. De accountant zorgt er samen
        met de ondernemer voor dat er een goed zicht op de financiën is en de
        administratie van het bedrijf goed ingericht wordt.
      </p>
      <p>De hoofdtaken van een AA-accountant zijn:</p>
      <ul>
        <li>
          Het opstellen, beoordelen of controleren van de jaarrekening. Met deze
          jaarrekening krijgt een ondernemer direct inzicht in zijn financiële
          status. En moet u onderhandelen over financieren bij een uitbreiding
          of bedrijfsovername? Ook dan is een betrouwbare en goedgekeurde
          jaarrekening een must.
        </li>
        <li>
          Het geven van fiscaal advies. Een AA-accountant verzorgt alle
          belastingaangiftes van een bedrijf, maar geeft ook advies als u daarom
          vraagt.
        </li>
        <li>
          Het geven van financieel-economisch advies. Ook met vragen over
          financieringsvormen en subsidies kunt u bij een AA-accountant terecht.
          Hij of zij vertelt u exact waar u voor in aanmerking kunt komen.
        </li>
        <li>
          Administratieve ondersteuning. De AA-accountant helpt een ondernemer
          bij het interpreteren van cijfers en draagt hiermee bij aan een gezond
          bedrijf.
        </li>
      </ul>
      <p>
        Kortom, de AA-accountant heeft een controlerende en adviserende functie
        met een breed takenpakket, waarbij de nadruk ligt op financieel en
        fiscaal gebied. Financiële gegevens zijn boven alles persoonlijke en
        vertrouwelijke informatie. Belangrijk is dan ook dat u hoge eisen stelt
        aan het vakmanschap en de integriteit van een accountant. Om de juiste
        keuze te kunnen maken, is het sterk aan te raden verschillende
        accountants met elkaar te vergelijken. Via Accountantvergelijker.nl kunt
        u geheel vrijblijvend 6 offertes aanvragen bij accountants in uw
        postcodegebied.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks.vue'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      title: 'Op zoek naar een accountant?',
      description:
        'Vul je postcode in en vergelijk geheel gratis 6 offertes van vakkundige Bedrijven uit jouw regio ✓ Dé beste prijs voor jouw Reparatie ✓ Bespaar tot 40%',
    }
  },
}
</script>
